// This class instantiates classes that create objects

//import * as THREE from 'three'
import Experience from '../Experience.js'
import Environment from "./Environment.js"
import Overlay from "./Overlay.js"
//import Assets from "./Assets.js"
import Sun from "./Sun.js"
import { 
    PlanetAnimation, MoonAnimationModeling, 
    MoonAnimationRigging, MoonAnimationAnimation,
    MoonAnimationSimulation 
} from "./PlanetAnimation.js"

import { 
    PlanetPhotography, MoonPhotographyPets,
    MoonPhotographyPeople, MoonPhotographyProducts,
    MoonPhotographyMisc
 } from "./PlanetPhotography.js"

 import {
    PlanetContact, MoonContactEmail,
    MoonContactYouTube, MoonContactInstagram,
    MoonContactLinkedIn
 } from "./PlanetContact.js"

 import {
    PlanetLab
 } from "./PlanetLab.js"

//import gsap from "gsap"

//import { overlay } from 'three/tsl'
//import Floor from "./Floor.js"
//import Fox from "./Fox.js"

export default class World{
    constructor(){
        //console.log("World Class")
        this.experience = new Experience()
        this.camera = this.experience.camera.instance
        this.orbitControls = this.experience.camera.controls
        //console.log("Orbit Controls", this.orbitControls)
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.getLoadingText()

        // Subscribe to resourses ready event
        // Ready event is dispatched after all assets in sources.js are loaded
        this.resources.addEventListener("ready", () =>{
            //console.log("Resoures are ready in the World class")
            // reset main content to display after content loads
            this.mainContent.style.display = "block"
            
            this.overlay = new Overlay()

            this.sun = new Sun()

            this.planetAnimation = new PlanetAnimation()
            this.moonAnimationModeling = new MoonAnimationModeling(this.planetAnimation)
            this.moonAnimationRigging = new MoonAnimationRigging(this.planetAnimation)
            this.moonAnimationAnimation = new MoonAnimationAnimation(this.planetAnimation)
            this.moonAnimationSimulation = new MoonAnimationSimulation(this.planetAnimation)
            
            this.planetPhotography = new PlanetPhotography()
            this.moonPhotographyPets = new MoonPhotographyPets(this.planetPhotography)
            this.moonPhotographyPeople = new MoonPhotographyPeople(this.planetPhotography)
            this.moonPhotographyProducts = new MoonPhotographyProducts(this.planetPhotography)
            this.moonPhotographyMisc = new MoonPhotographyMisc(this.planetPhotography)

            this.planetContact = new PlanetContact()
            this.moonContactEmail = new MoonContactEmail(this.planetContact)
            this.moonContactYouTube = new MoonContactYouTube(this.planetContact)
            this.moonContactInstagram = new MoonContactInstagram(this.planetContact)
            this.moonContactLinkedIn = new MoonContactLinkedIn(this.planetContact)

            this.planetLab = new PlanetLab()

            this.environment = new Environment()
            
        })
    }

    update(){
        let percent = (this.resources.loaded / this.resources.toLoad) * 100
        let percentFixed = percent.toFixed(2)
        this.loadingText.innerHTML = `${percentFixed}%`
    }

    getLoadingText(){
        //prevent pre-load flash of unstyled page by hiding it till load completes
        // it is initially hidden due to inline stlyling
        this.mainContent = document.querySelector(".mainContent")
        this.loadingText = document.querySelector(".loader--percent")
        
    }

    
}